import { Blockquote, Text } from "@radix-ui/themes";

export default function CuttingAcrossBanner() {
  return (
    <>
      <div className="container">
        <div className='row pt-3 d-flex justify-content-cent'>
          <div className='col d-flex justify-content-center'>
            <Text size="6" weight="bold" color>
              Cutting Across
            </Text>
          </div>
        </div>
        <div className='row py-3 border-bottom d-flex justify-content-cent'>
          <div className='col d-flex justify-content-center'>
            <Text size="4" color> 
              Philosophy | 
              Anthropology | 
              Psychology | 
              Religion | 
              Literature |  
              Arts | 
              Sociology |  
              Politics
            </Text>
          </div>
        </div>
        
      </div>
    </>
  )
}
